import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastService } from '@cnt-workspace/data-access';

/**
 * Renders cnt-landing's ToastService queue (used by AuthService and the
 * admin screens). cnt-landing's own ToastHostComponent relies on its Tailwind
 * theme, which the admin app doesn't load, so this is a plain-CSS equivalent.
 */
@Component({
  selector: 'admin-toast-host',
  standalone: true,
  imports: [AsyncPipe],
  template: `
    <div class="toast-stack" aria-live="polite">
      @for (toast of toasts.toasts$ | async; track toast.id) {
        <div class="toast" [class]="'toast toast-' + toast.tone" role="status">
          <span>{{ toast.message }}</span>
          @if (toast.actionLabel) {
            <button type="button" (click)="toast.action?.(); toasts.dismiss(toast.id)">{{ toast.actionLabel }}</button>
          }
          <button type="button" aria-label="Dismiss" (click)="toasts.dismiss(toast.id)">×</button>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toast-stack {
        position: fixed;
        right: 16px;
        bottom: 16px;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-width: min(420px, calc(100vw - 32px));
      }
      .toast {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px;
        border-radius: 8px;
        color: #fff;
        background: #333;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        font-size: 14px;
      }
      .toast span {
        flex: 1;
      }
      .toast-success { background: #295d42; }
      .toast-error { background: #b3261e; }
      .toast-warn { background: #b26a00; }
      .toast-info { background: #37474f; }
      button {
        background: transparent;
        border: 0;
        color: inherit;
        font-weight: 600;
        cursor: pointer;
      }
    `,
  ],
})
export class AdminToastHostComponent {
  readonly toasts = inject(ToastService);
}
